import { motion } from "framer-motion";
import personalPic from "../assets/picture-about.svg";
import shortDecor from "../assets/short-decor.svg";
import longDecor from "../assets/long-decor.svg";
import Title from "../components/Title";
function About() {
  return (
    <section className="relative mb-24 lg:my-48 " id="about">
      {/* this div is just to have a fixed cotainer  */}
      <div className="el-container-lg flex justify-center lg:justify-between items-center flex-wrap-reverse">
        {/* description */}
        <div className=" mt-12 lg:mt-0 max-w-md">
          {/* title */}
          <Title title="About" />
          <p className="my-6">
            I’m a passionate front-end web developer and a UI/UX designer. I love learning
            new technologies and techniques to make sure I’m always up to date in the
            industry.
          </p>
          <button>my resume</button>
        </div>
        {/* section image */}
        <div>
          <motion.img
            initial={{ scale: 0 }}
            whileInView={{
              scale: 1,
              transition: {
                ease: [0.6, 0.01, -0.05, 0.95],
                duration: 0.5,
              },
            }}
            viewport={{ once: true }}
            src={personalPic}
            alt="author"
          />
        </div>
      </div>
      {/* decoration asset */}
      <div className="absolute el-decor -bottom-36 left-0">
        <img src={longDecor} alt="" />
      </div>
      <div className="absolute el-decor -top-14 right-0">
        <img src={shortDecor} alt="" />
      </div>
    </section>
  );
}

export default About;
